import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Track from 'track/Track.js';
import {WIDTH} from '../pianoroll/constants.js';

const PianoRollPlayTick = ({currentStep, resolution, xScale, height}) => { 
    let style = {
        left: Math.max(0, WIDTH * xScale * currentStep) - 8,
        height: height
    };
    return (
        <div
          style={style}
          className="piano-roll-play-tick">
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.getSequenceId();
    let resolution = state.sequencer.displayResolution;
    if (props.track.pattern.startStep !== undefined) {
        let trackStep = props.sequencerEngine.trackStep - props.track.pattern.startStep;
        return {
            resolution,
            currentStep: trackStep
        };
    }
    var currentStep = 
        props.sequencerEngine.trackStepReal || 0; 
    currentStep = Math.ceil(props.track.getPatternStep(currentStep) /
            (Track.baseResolution.numSteps() /
             state.sequencer.displayResolution.numSteps()));

    return {
        currentStep: currentStep,
        resolution: resolution
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoRollPlayTick);
